exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".reduce-fab{width:40px!important;height:40px!important}", "", {"version":3,"sources":["/home/circleci/repo/src/pages/grouppage/members.vue"],"names":[],"mappings":"AACA,YACI,qBAAuB,AACvB,qBAAwB,CAC3B","file":"members.vue","sourcesContent":["\n.reduce-fab {\n    width: 40px !important;\n    height: 40px !important;\n} \n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4e9938d3","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/grouppage/members.vue
// module id = 1386
// module chunks = 17